export default __webpack_public_path__ + "static/media/whatsapp.965d92ce.png";